<script>
  import { format } from "date-fns";
  import { fade } from "svelte/transition";
  import { conversion, lang } from "../../store/store.js";
  import { db, user } from "../../firebase";
  export let notification;

  let userinfo;
  $user.doc.subscribe((v) => {
    userinfo = v;
  });

  let convert = (k) => {
    k = Math.abs(k);
    let output = "";
    let hrs = k / 60;
    if (hrs <= 0) {
      hrs = Math.ceil(hrs);
    } else {
      hrs = Math.floor(hrs);
    }
    if (hrs != 0) {
      output = hrs + " " + " H";
    }
    let minutes = Math.abs(k) - Math.abs(hrs) * 60;
    if (minutes != 0) {
      if (hrs != 0) {
        output = output + " " + minutes + " M";
      } else {
        output = output + minutes + " " + " M";
      }
    }
    if (minutes == 0 && hrs == 0) {
      output = "0 " + " M";
    }
    return output;
  };
  console.log(notification.date);
  let date = format(new Date(parseInt(notification.date)), "d MMM h:mm aaa");
</script>

<style>
  a {
    color: #3f8cff;
  }
  .row {
    display: flex;
    flex-direction: row;
  }

  .n-ctn {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    padding: 1.5rem 2rem 1.4rem 2rem;
  }

  .u-img {
    display: flex;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 0.75rem;
    min-width: 46px;
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .status-change {
    margin-bottom: 0.75rem;
    color: #0a1629;
  }

  .status-change p {
    margin: 0;
  }

  .date {
    color: #7d8592;
    font-size: 0.875em;
  }

  .flex-end {
    display: flex;
    margin-left: auto;
    align-items: center;
  }
  .enlarge {
    margin-right: 1.25rem;
    cursor: pointer;
  }
  .email {
    cursor: pointer;
  }
</style>

<div transition:fade={{ duration: 300 }} class="row n-ctn">
  <div class="u-img">
    {#if notification.changedField == 'debit'}
      <img src={userinfo.account.img} alt="" />
    {:else}
      <img
        src={notification.profilePicture || '../images/user/user.png'}
        alt="" />
    {/if}
  </div>
  <div class="column">
    {#if notification.changedField == 'status'}
      <div class="status-change">
        <p>
          <b>{notification.username.split(' ')[0]}</b>
          {$conversion[$lang].notifications.status[1]}
          <b>{notification.name} </b>
          {$conversion[$lang].notifications.status[2]}
          <a
            class="redirection"
            href="/tasks/{notification.taskid}">{notification.change.status}</a>
        </p>
      </div>
    {/if}
    {#if $lang == 'en'}
      {#if notification.changedField == 'comment'}
        <div class="status-change">
          <p>
            <b>{notification.username.split(' ')[0]}</b>
            {$conversion[$lang].notifications.comment[1]}
            <a
              class="redirection"
              href="/TaskItemDetails/{notification.taskid}"><b>{notification.name}</b></a>
            {$conversion[$lang].notifications.comment[2]}
          </p>
        </div>
      {/if}
      {#if notification.changedField == 'assignee_add'}
        <div class="status-change">
          <p>
            <b>{notification.username.split(' ')[0]}</b>
            {$conversion[$lang].notifications.assigneeAdd[1]}
            <b>{notification.change.username}</b>
            {$conversion[$lang].notifications.assigneeAdd[2]}
            <a
              class="redirection"
              href="/TaskItemDetails/{notification.taskid}"><b>{notification.name}</b></a>
            {$conversion[$lang].notifications.assigneeAdd[3]}
          </p>
        </div>
      {/if}
      {#if notification.changedField == 'assignee_rem'}
        <div class="status-change">
          <p>
            <b>{notification.username.split(' ')[0]}</b>
            {$conversion[$lang].notifications.assigneeRemove[1]}
            <b>{notification.change.username}</b>
            {$conversion[$lang].notifications.assigneeRemove[2]}
            <a
              class="redirection"
              href="/TaskItemDetails/{notification.taskid}"><b>{notification.name}</b></a>
            {$conversion[$lang].notifications.assigneeRemove[3]}
          </p>
        </div>
      {/if}
    {:else}
      {#if notification.changedField == 'comment'}
        <div class="status-change">
          <p>
            <b>{notification.username.split(' ')[0]}</b>
            {$conversion[$lang].notifications.comment[1]}
            {$conversion[$lang].notifications.comment[2]}
            <a
              class="redirection"
              href="/TaskItemDetails/{notification.taskid}"><b>{notification.name}</b></a>
          </p>
        </div>
      {/if}
      {#if notification.changedField == 'assignee_add'}
        <div class="status-change">
          <p>
            <b>{notification.username.split(' ')[0]}</b>
            {$conversion[$lang].notifications.assigneeAdd[1]}
            <b>{notification.change.username}</b>
            {$conversion[$lang].notifications.assigneeAdd[2]}
            {$conversion[$lang].notifications.assigneeAdd[3]}
            <a
              class="redirection"
              href="/TaskItemDetails/{notification.taskid}"><b>{notification.name}</b></a>
          </p>
        </div>
      {/if}
      {#if notification.changedField == 'assignee_rem'}
        <div class="status-change">
          <p>
            <b>{notification.username.split(' ')[0]}</b>
            {$conversion[$lang].notifications.assigneeRemove[1]}
            <b>{notification.change.username}</b>
            {$conversion[$lang].notifications.assigneeRemove[2]}
            {$conversion[$lang].notifications.assigneeRemove[3]}
            <a
              class="redirection"
              href="/TaskItemDetails/{notification.taskid}"><b>{notification.name}</b></a>
          </p>
        </div>
      {/if}
      {#if notification.changedField == 'debit'}
        <div class="status-change">
          <p>
            <b>{$conversion[$lang].notifications.addBalance[0]}</b>
            {$conversion[$lang].notifications.addBalance[1]}
            {convert(notification.addHrs)}
            <a
              class="redirection"
              href="/transaction-history"><b>{$conversion[$lang].notifications.addBalance[2]}</b></a>
          </p>
        </div>
      {/if}
    {/if}
    <div class="date">{date}</div>
  </div>
  <div class="flex-end">
    <a href="/TaskItemDetails/{notification.taskid}" class="enlarge">
      <img src="../images/notification/enlarge.svg" alt="" />
    </a>
  </div>
</div>
